// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import constants from "@store/constants";
import { getStoreListShipTosDataView } from "@store/Framework/Store/Data/StoreListDetails/StoreListDetailsSelector";
import updateCustomersPagination from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/UpdateCustomersPagination";
import { FC } from "react";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    listStore: getStoreListShipTosDataView(state, state.store.pages.storeListsDetails.customersParameter),
});

const mapDispatchToProps = {
    updateCustomersPagination,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface StoreListsDetailsPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const storeListsDetailsPaginationStyles: StoreListsDetailsPaginationStyles = {
    pagination: {
        cssOverrides: {
            pagination: css`
                justify-content: center;

                && {
                    margin-top: ${x => x.theme.design.myAccount.pagination.spacing};
                }
            `,
        },
    },
};

const styles = storeListsDetailsPaginationStyles;

const StoreListsDetailsPagination: FC<Props> = ({ listStore, updateCustomersPagination }) => {
    if (!listStore.value || !listStore.pagination) {
        return null;
    }
    const onChangePage = (newPageIndex: number) => {
        updateCustomersPagination({ page: newPageIndex });
    };

    const onChangeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {};

    const { pagination } = listStore;

    if (!pagination) {
        return <></>;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={onChangePage}
            onChangeResultsPerPage={onChangeResultsPerPage}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(StoreListsDetailsPagination),
    definition: {
        group: constants.widgetGroup.storeListDetails,
        displayName: "Store List Pagination",
        allowedContexts: ["StoreListDetailPage"],
    },
};

export default widgetModule;
